<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>补课时记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false">
        <Row >
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="申请时间">
                <Col >
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               @on-change="startTimeDateChange"
                               v-model="queryParam.startTimeDate"></Date-picker>
                </Col>
                <Col >
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               @on-change="endTimeDateChange"
                               v-model="queryParam.endTimeDate"></Date-picker>
                </Col>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="申请人昵称">
              <Input placeholder="支持模糊搜索" name="adminNickname"
                     v-model="queryParam.adminNickname"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="申请人邮箱" >
              <Input placeholder="支持模糊搜索" name="adminMobile"
                     v-model="queryParam.adminMobile"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="学生ID">
              <Input name="uid"
                     v-model="queryParam.uid"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item  label="学生手机号">
              <Input placeholder="支持模糊搜索" name="userMobile"
                     v-model="queryParam.userMobile"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="学生姓名" >
              <Input placeholder="支持模糊搜索" name="userNickname"
                     v-model="queryParam.userNickname"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="状态">
              <Select v-model.number="queryParam.status" placeholder="全部" @on-change="search" clearable>
                <Option v-for="item in $constant.bookCourseChangeStatus"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="赠课类型">
              <Select v-model.number="queryParam.givingType" placeholder="全部" @on-change="changeGivingType" clearable>
                <Option v-for="item in $constant.givingType"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Select v-model.number="queryParam.givingTypeChild" placeholder="全部" @on-change="search" clearable>
              <Option v-for="item in givingTypeChild"
                      :value="item.code" :key="item.code">{{ item.text }}
              </Option>
            </Select>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="老师">
              <TeacherSelect :category="[1, 2]" v-model.number="queryParam.tchId" @on-change="search"
                             clearable></TeacherSelect>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="审核人">
              <Input v-model="queryParam.checkAdmin" placeholder="支持模糊搜索" name="checkAdmin"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="申请类型">
              <Select v-model.number="queryParam.subType" @on-change="search" clearable>
                <Option v-for="item in $constant.addSubType" :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="课程类型">
              <Select v-model.number="queryParam.courseType" @on-change="search" clearable>
                <Option v-for="item in $constant.courseType" :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="申请部门">
              <Select v-model.number="queryParam.applyDepartment" placeholder="全部" @on-change="search" clearable>
                <Option v-for="item in $constant.applyDepartment"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col >
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search">搜索
            </Button>
            <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="" v-perm="'280'"
                    @click="exportData">导出
            </Button>
            <Button type="error" @click="openUserClassHourModal" icon="plus-round">加减课时</Button>
            <Button type="error" @click="openBatchCourseChangeModal" icon="plus-round">批量减课时,慎重操作</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookCourseChange/list"
          :params="queryParam" :onLoading="onLoading" operator="" @on-selection-change="selectionChange"></List>
    <UserInfoModal :value="editUser" @on-close="closeModal" :uid="uid" :successCallback="search"></UserInfoModal>
    <ShowImageCarousel :imgList="showImgList" :value="showImgModal" @on-close="closeImgModal"></ShowImageCarousel>
    <UserClassHourModal :show-uid='true' v-model="showUserClassHourModal"></UserClassHourModal>

    <BatchCourseChangeModal :successCallback="search"
                            v-model="showBatchCourseChangeModal"></BatchCourseChangeModal>
    <Modal title="审核拒绝" v-model="showRejectModal">
      <Form ref="rejectForm" :model="rejectParam" :rules="rejectRule" :label-width="90">
        <Form-item label="拒绝原因" prop="memo">
          <Input type="textarea" :autosize="{minRows: 2, maxRows: 4}" :maxlength="200"
                 placeholder="请填写拒绝原因，将通知申请人"
                 v-model="rejectParam.memo"></Input>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showRejectModal=false">取消</Button>
        <Button type="error" size="large" :loading="rejectLoading" @click="submitReject">拒绝</Button>
      </div>
    </Modal>
  </div>

</template>
<script>
import UserInfoModal from '../crm/UserInfoModal.vue'
import ShowImageCarousel from '../order/ShowImageCarousel'
import UserClassHourModal from "./UserClassHourModal.vue";
import BatchCourseChangeModal from "./BatchCourseChangeModal.vue";
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'

export default {
  components: {
    BatchCourseChangeModal,
    UserClassHourModal,
    ShowImageCarousel,
    UserInfoModal
  },
  data() {
    let $constant = this.$constant
    let $moment = this.$moment
    return {
      searchLoading: false,
      exportLoading: false,
      passLoading: false,
      rejectLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      editUser: false,
      uid: null,
      selectionUser: [],
      showImgList: [],
      givingTypeChild: [],
      showImgModal: false,
      showUserClassHourModal: false,
      showBatchCourseChangeModal: false,
      showRejectModal: false,
      rejectParam: {
        id: null,
        memo: ''
      },
      rejectRule: {
        memo: [
          {required: true, message: '请填写拒绝原因', trigger: 'blur'}
        ]
      },
      queryParam: {
        uid: '',
        userMobile: '',
        userNickname: '',
        adminNickname: '',
        adminMobile: '',
        startTimeDate: '',
        endTimeDate: '',
        startTime: '',
        endTime: '',
        status: null,
        givingType: '',
        givingTypeChild: '',
        tchId: null,
        subType: null,
        checkAdmin: '',
        courseType: null,
        applyDepartment: ''
      },

      title: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '学生ID/姓名',
          width: 150,
          render: (h, params) => {
            let row = params.row
            return h('a', {on: {click: () => this.openInfoModal(row.uid)}}, row.uid + '-' + row.userNickname)
          }
        },
        {
          title: '课程类别',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let courseType = params.row.courseType
            let typeEnum = $constant.getEnum($constant.courseType, courseType)
            return h('span', typeEnum && typeEnum.text)
          }
        },
        {
          title: '申请类型',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let type = params.row.type
            let typeEnum = $constant.getEnum($constant.addSubType, type)
            return h('span', typeEnum && typeEnum.text)
          }
        },
        {
          title: '加减课时',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let type = params.row.type
            let num = 0
            if (type === 1 || type === 2) {
              num = type === 2 ? -params.row.num : params.row.num
            }
            return h('span', num)
          }
        },
        {
          title: '加减请假次数',
          align: 'center',
          width: 150,
          render: (h, params) => {
            let type = params.row.type
            let num = 0
            if (type === 3 || type === 4) {
              num = type === 4 ? -params.row.num : params.row.num
            }
            return h('span', num)
          }
        },
        {
          title: '加减补课次数',
          align: 'center',
          width: 150,
          render: (h, params) => {
            let type = params.row.type
            let num = 0
            if (type === 5 || type === 6) {
              num = type === 6 ? -params.row.num : params.row.num
            }
            return h('span', num)
          }
        },
        {
          title: '一级类型',
          key: 'givingType',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let givingType = params.row.givingType
            let givingTypeEnum = $constant.getEnum($constant.givingTypeEnum, givingType)
            return h('span', givingTypeEnum && givingTypeEnum.text)
          }
        },
        {
          title: '二级类型',
          key: 'givingTypeChild',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let givingTypeChild = params.row.givingTypeChild
            let givingTypeChildEnum = $constant.getEnum($constant.givingTypeChildEnum, givingTypeChild)
            return h('span', givingTypeChildEnum && givingTypeChildEnum.text)
          }
        },
        {
          title: '申请时间',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let createTime = params.row.createTime
            return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm'))
          }
        },
        {
          title: '凭证',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.url) {
              return h('a', {on: {click: () => this.viewPic(row)}}, '查看')
            } else {
              return h('span', '')
            }
          }
        },
        {
          title: '状态',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let status = params.row.status
            let statusEnum = $constant.getEnum($constant.bookCourseChangeStatus, status)
            return h('span', statusEnum && statusEnum.text)
          }
        },
        {
          title: '审核人',
          key: 'checkAdmin',
          width: 100,
          align: 'center',
        },
        {
          title: '审核时间',
          key: 'checkTime',
          width: 110,
          align: 'center',
        },
        {
          title: '原因',
          key: 'reason',
          width: 300,
          align: 'center',
        },
        {
          title: '申请人',
          key: 'adminNickname',
          width: 100,
          align: 'center',
        },
        {
          title: '老师',
          width: 160,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.tchId ? (row.tchId + '-' + row.tchName) : '',
              score: row.monthRankScore
            })
          }
        },
        {
          title: '外教运营',
          width: 110,
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.foreignOperations ? params.row.foreignOperations : '')
          }
        },
        {
          title: '备注/拒绝原因',
          width: 180,
          key: 'memo',
          align: 'center',
        },
        {
          title: '操作',
          align: 'center',
          width: 110,
          render: (h, params) => {
            let status = params.row.status
            if (status === 0 || status === 3) {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      this.onPass(params.row)
                    }
                  }
                }, '通过'),
                h('span', {class: 'divider'}),
                h('a', {
                  on: {
                    click: () => {
                      this.onReject(params.row)
                    }
                  }
                }, '拒绝')
              ])
            }
          }
        }
      ]
    }
  },
  mounted: function () {
  },
  created: function () {
    let startTime = this.queryParam.startTime
    if (startTime !== '') {
      this.queryParam.startTimeDate = this.$moment.unix(startTime).toDate()
    }
    if (startTime === '') {
      let momentDate = this.$moment().add(-3, 'M')
      momentDate.millisecond(0)
      momentDate.second(0)
      momentDate.minute(0)
      momentDate.hour(0)
      this.queryParam.startTimeDate = momentDate.toDate()
      this.queryParam.startTime = momentDate.format('X')
    }
  },
  methods: {
    closeImgModal() {
      this.showImgList = []
      this.showImgModal = false
    },
    viewPic(row) {
      this.showImgList = row.urls
      this.showImgModal = true
    },
    closeModal(val) {
      this.uid = null
      this.editUser = val
    },
    openInfoModal(val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookCourseChangeList'}
      })
      window.open(href, '_blank')
    },
    search() {
      this.reload = new Date().getTime()
    },
    changeGivingType(val) {
      let self = this
      if (val === 1) {
        self.givingTypeChild = []
      } else if (val === 2) {
        self.givingTypeChild = [{code: 10, text: '转介绍成功购课'}, {code: 11, text: '邀请好友试听成功'}]
      } else if (val === 3) {
        self.givingTypeChild = [{code: 8, text: '特殊请假'}, {code: 9, text: '家长态度强硬非要返还课时'}]
      } else if (val === 4) {
        self.givingTypeChild = []
      } else if (val === 5) {
        self.givingTypeChild = [{code: 1, text: '课件编辑错'}]
      } else if (val === 6) {
        self.givingTypeChild = [{code: 2, text: '老师离职'}, {code: 3, text: '老师旷课'}, {
          code: 4,
          text: '老师迟到10分钟以及以上'
        }, {code: 5, text: '老师网络原因不能上课'}]
      } else if (val === 7) {
        self.givingTypeChild = [{code: 6, text: '教材不顺延'}, {code: 7, text: '课件排错'}]
      } else if (val === 8) {
        self.givingTypeChild = []
      } else if (val === 9) {
        self.givingTypeChild = []
      }
      this.reload = new Date().getTime()
    },
        onLoading (loading) {
      this.searchLoading = loading
      if (!loading) {
        this.loadMonthRankScores()
      }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },
    exportData(type) {
      this.exportLoading = true
      this.$http.get('/bookCourseChange/export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        let blob = new Blob([response.data], {type: 'text/csv'})
        let link = document.createElement('a')
        link.target = '_blank'
        link.href = window.URL.createObjectURL(blob)
        link.download = '补课时记录.csv'
        link.click()
        this.exportLoading = false
      }).catch((e) => {
        this.exportLoading = false
      })
    },
    startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    isAutoInviteGift (row) {
      return /^被邀请人【\d+】上满一个月转介绍自动赠课$/.test((row && row.reason) || '')
    },
    blockManualInviteGift (rows) {
      const list = rows || []
      for (let i = 0; i < list.length; i++) {
        if (this.isAutoInviteGift(list[i])) {
          this.$Message.warning('不需要人工操作')
          return true
        }
      }
      return false
    },
    onPass(row) {
      if (this.blockManualInviteGift([row])) {
        return
      }
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否 <b>通过</b> 此次申请？',
        width: 300,
        okText: '确定通过',
        loading: true,
        onOk: () => {
          self.$http.post('/bookCourseChange/pass', {id: row.id}).then(function (res) {
            self.search()
            if (res && res.data == -1) {
              self.$Message.success('进入复审中!')
            } else {
              self.$Message.success('提交成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    onReject(row) {
      if (this.blockManualInviteGift([row])) {
        return
      }
      this.rejectParam.id = row.id
      this.rejectParam.memo = ''
      this.showRejectModal = true
    },
    submitReject() {
      let self = this
      this.$refs.rejectForm.validate((valid) => {
        if (!valid) {
          this.$Message.warning('请填写拒绝原因')
          return
        }
        self.rejectLoading = true
        self.$http.post('/bookCourseChange/reject', {
          id: self.rejectParam.id,
          memo: self.rejectParam.memo
        }).then(function (res) {
          self.rejectLoading = false
          self.showRejectModal = false
          self.search()
          self.$Message.success('提交成功!')
        }).catch(function () {
          self.rejectLoading = false
        })
      })
    },
    selectionChange(selection) {
      this.selectionUser = selection
    },
    batchPass() {
      if (this.blockManualInviteGift(this.selectionUser)) {
        return
      }
      this.passLoading = true
      let ids = []
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (let i in this.selectionUser) {
          let dto = this.selectionUser[i]
          ids[i] = dto.id
        }
      }
      let self = this
      this.$http.post('/bookCourseChange/batchReview', {ids: ids.join(','), status: 1}).then((res) => {
        if (res && res.data > 0) {
          self.$Message.success('批量通过成功！')
          self.passLoading = false
          self.search()
        } else {
          self.$Message.error('批量通过失败！')
          self.passLoading = false
        }
      }).catch((e) => {
        this.passLoading = false
      })
    },
    batchReject() {
      if (this.blockManualInviteGift(this.selectionUser)) {
        return
      }
      this.rejectLoading = true
      let ids = []
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (let i in this.selectionUser) {
          let dto = this.selectionUser[i]
          ids[i] = dto.id
        }
      }
      let self = this
      this.$http.post('/bookCourseChange/batchReview', {ids: ids.join(',') + '', status: 2, memo: this.rejectParam.memo}).then((res) => {
        if (res && res.data > 0) {
          self.$Message.success('批量拒绝成功！')
          self.rejectLoading = false
          self.search()
        } else {
          self.$Message.error('批量拒绝失败！')
          self.rejectLoading = false
        }
      }).catch((e) => {
        self.$Message.error('批量拒绝失败！')
        self.rejectLoading = false
      })
    },
    openUserClassHourModal() {
      this.showUserClassHourModal = true
    },
    openBatchCourseChangeModal() {
      this.showBatchCourseChangeModal = true
    },
  }
}

</script>



// WEBPACK FOOTER //
// BookCourseChangeList.vue?4ad5449a